import { get, patch, post, postFormData } from '@/helpers/httpHandler';

export default {
  namespaced: true,

  state: {},

  getters: {},

  mutations: {},

  actions: {
    index: () => get('communication-options'),
    store: (_, data) => post('/communication-options', data),
    show: (_, id) => get(`communication-options/${id}`),
    update: (_, payload) => patch(`communication-options/${payload.id}`, payload),
    person: (_, id) => get(`/persons/${id}/communication-options`),
    assign: (_, { person_id, personOptions }) =>
      patch(`/persons/${person_id}/communication-options`, personOptions)
  }
};
